import { useTranslation } from "react-i18next";

/**
 * Thin wrapper around react-i18next's useTranslation. Returns the `t`
 * function directly — no namespace argument because we use one shared
 * namespace ("translation") for the whole catalog.
 *
 * Usage:
 *   const t = useT();
 *   t("schrijven.home.startExam")
 *   t("chrome.header.greetingHelloFmt", { name: user.displayName })
 */
export function useT(): (key: string, params?: Record<string, unknown>) => string {
  const { t } = useTranslation();
  return (key, params) => t(key, params ?? {}) as string;
}
